import { ChangeEvent } from 'react'

import ComponentStyled, { CustomizedTextArea } from './styled'

type Props = {
  placeholder?: string
  value?: string
  onChange?: (event: ChangeEvent<HTMLTextAreaElement>) => void
  error?: string
  label?: string
  spacingBottom?: number
}

const TextArea = ({ placeholder, onChange, error = '', label = '', spacingBottom = 0, value }: Props): JSX.Element => (
  <ComponentStyled spacingBottom={spacingBottom}>
    {label && <p className='input-label'>{label}</p>}
    <CustomizedTextArea onChange={onChange} placeholder={placeholder} value={value} />
    {error && <p className='input-error'>{error}</p>}
  </ComponentStyled>
)

export default TextArea
